import * as z from "zod";

export const nullSchema = z.null();
export const emptyStringSchema = z.string().length(0);

// TODO : the api is quite inconsistent concerning what it returns from POST requests. It might be null, a string or an empty string. We try to be exhaustive here to avoid false feedback in the app.
export const emptySchema = z.union([nullSchema, z.string()]);
